
import {tap, catchError, filter, take, switchMap} from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError, BehaviorSubject, of  } from 'rxjs';

import { ToasterService } from 'angular2-toaster';
import { CurrentUser } from '../services/currentUser.service';
import { AccountService } from '../+account/account.service';
import { Tokens } from '../_models/Token.model';
import { environment } from 'environments/environment';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private currentUser: CurrentUser,
    private router: Router,
    private toasterService: ToasterService,
    private injector: Injector,
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.currentUser.getJwtToken()) {
      req = this.addToken(req, this.currentUser.getJwtToken());
    }
    return next.handle(req).pipe(catchError(
      event => {
        if (typeof event.error === 'string') {
          event.error = JSON.parse(event.error);
        }
        if (event instanceof HttpErrorResponse) {
          if (event.status === 401) {
              if (req.url.includes('refresh')) {
                this.currentUser.clear();
                setTimeout(() => {
                  const accountService = this.injector.get(AccountService);
                  if (!accountService.isModalShown) {
                    this.router.navigate(['/account/login']);
                  }
                });
                return of(null);
              } else if (req.url.includes('token')) {
                this.toasterService.pop('error', undefined, event.error.detail);
              }
              if (req.method === 'POST' && req.url.includes('token')) {
                return of(null);
              } else if (!this.isRefreshing) {
                  this.isRefreshing = true;
                  this.refreshTokenSubject.next(null);
                  return this.currentUser.refreshToken().pipe(
                    switchMap((token: Tokens ) => {
                        if (token.access_token) {
                            this.isRefreshing = false;
                            this.refreshTokenSubject.next(token.access_token);
                            return next.handle(this.addToken(req, token.access_token));
                        }
                    }));
              } else {
                  return this.refreshTokenSubject.pipe(
                    filter(token => token != null),
                    take(1),
                    switchMap(access => {
                      return next.handle(this.addToken(req, access));
                    }));
              }
          }

          if (event.status === 403) {
            this.router.navigate(['/stories']);
            if (event.error.detail) {
              this.toasterService.pop('error', undefined, event.error.detail);
            }
          }

          if (event.status === 400) {
            if (req.url.includes('refresh')) {
              this.router.navigate(['/account/login/'], { queryParams: { next: this.router.url} });
              return of(null);
            } else {
              return next.handle(req);
            }
          }
          if (event.status === 404 || event.status === 409) {
            return next.handle(req);
          }
        }
      }
    ));
  }
  private addToken(request: HttpRequest<any>, token: string) {
    const requestend = request.clone({
        headers: request.headers.set('Authorization', token ? 'Bearer ' + token : undefined)
    });
    return requestend;
}
}
